import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { DeviceInfo } from '../model/types';
import type { Repo } from '../store/repo';
import type { StorageStatus } from '../store/persistence';

export interface AppEnv {
  repo: Repo;
  device: DeviceInfo;
  storage: StorageStatus;
  /** Strokes recovered from the journal at startup. */
  recovered: number;
}

export const AppContext = createContext<AppEnv | null>(null);

export function useApp(): AppEnv {
  const env = useContext(AppContext);
  if (!env) throw new Error('AppContext missing');
  return env;
}
